<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>KIDNAPPED BY   THE TALIBAN </title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="txc1" id="p0021-01-0"><a id="pagexxi"><i>The first time we meet, we are friends. The   next time we meet, we are   brothers.</i><br/>—A<span class="small">FGHAN PROVERB</span></a></p><a id="pagexxi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// forward2.vue?077eaca7